import React, { JSX } from 'react'
import type { Image } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'

export type CardHorizontalProps = {
  anchorID?: string
  title?: string
  summary?: string
  customContent?: JSX.Element
  mainImage: Image
  mainImageAltText?: string
  stretchImage?: boolean
  reversed?: boolean
  categoryName?: string
}

export const CardHorizontal = ({
  title,
  anchorID,
  summary,
  mainImage,
  mainImageAltText,
  reversed,
  customContent,
  stretchImage,
}: CardHorizontalProps) => {
  return (
    <div className={`card-horizontal`}>
      <div className={`row ${reversed ? 'card-horizontal__row_reversed' : ''}`}>
        <div className="col-12 col-md-6 order-md-0 order-last">
          <div className="card-horizontal__wrap">
            {title ? (
              <h3 id={anchorID} className="u-fs-28 card-horizontal__title">
                {title}
              </h3>
            ) : null}
            {summary ? (
              <div
                className="u-fs-16 card-horizontal__description"
                dangerouslySetInnerHTML={{ __html: summary }}
              />
            ) : null}
            {customContent ? customContent : null}
          </div>
        </div>
        {mainImage?.url ? (
          stretchImage ? (
            <div className="col-12 col-md-6 u-mb-md-0 u-mb-8">
              <div
                className="card-horizontal__image"
                style={{ backgroundImage: `url(${mainImage.url})` }}></div>
            </div>
          ) : (
            <div className="col-12 col-md-6 u-mb-md-0 u-mb-8 d-flex justify-content-center align-items-center">
              <img src={mainImage.url} alt={mainImageAltText || title || ''} />
            </div>
          )
        ) : null}
      </div>
    </div>
  )
}
